import { render, staticRenderFns } from "./HandAndMeldedBlocks.vue?vue&type=template&id=6d9f8b2f&scoped=true"
import script from "./HandAndMeldedBlocks.vue?vue&type=script&lang=js"
export * from "./HandAndMeldedBlocks.vue?vue&type=script&lang=js"
import style0 from "./HandAndMeldedBlocks.vue?vue&type=style&index=0&id=6d9f8b2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9f8b2f",
  null
  
)

export default component.exports